import React from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="navigation-header">
      <div className="container">
        <div className="navigation-content">
          <Link to="/" className="navigation-logo">
            <img 
              src="/logo.png"
              alt="Harvest Holdings" 
              className="logo-image"
            />
          </Link>
          
          <nav className="navigation-menu">
            <Link 
              to="/" 
              className={`navigation-link ${isActive("/") ? "active" : ""}`}
            >
              Home
            </Link>
            <Link 
              to="/portfolio" 
              className={`navigation-link ${isActive("/portfolio") ? "active" : ""}`}
            >
              Portfolio
            </Link>
            <Link 
              to="/about" 
              className={`navigation-link ${isActive("/about") ? "active" : ""}`}
            >
              About
            </Link>
            <Link 
              to="/contact" 
              className={`navigation-link ${isActive("/contact") ? "active" : ""}`}
            >
              Contact
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;